module.exports = __webpack_public_path__ + "static/media/essaimageCoralien.63fdace6.jpeg";